import React, { ComponentType } from 'react';
import { useParams } from 'react-router';
import { OmitStrict } from '@tink/core/src/types';
import { BuildTppToWebUrl } from '../../../routes/routeBuilder';
import { RedirectingBackToScreenProps } from '../RedirectResult/molecules/RedirectingBackToScreen';
import { RedirectBackToWeb } from '../RedirectResult/RedirectBackToWeb';

export type AppToWebResultPageProps = {
  RedirectBack?: ComponentType<RedirectingBackToScreenProps>;
};

export const TppToWebResultPage = ({
  RedirectBack = RedirectBackToWeb,
}: AppToWebResultPageProps) => {
  const { clientName } = useParams<OmitStrict<BuildTppToWebUrl, 'origin'>>();

  return <RedirectBack clientName={clientName} />;
};
